import React from 'react';
import { Typography, AppImage, Icon } from '@/app/common';
import { cn } from '@workspace/lib';
import { IconMap } from '@workspace/ui/common/IconMap';
import { ContactInfoProps } from '../contact-support.types';
import { isIconKey } from '../lib/contact-support.utils';
import { SmartLink } from './SmartLink';

export function ContactInfo({ items }: ContactInfoProps) {
  if (!items?.length) return null;

  const iconBox = 'relative inline-grid place-items-center h-6 w-6 shrink-0';

  return (
    <div className="flex flex-col gap-2">
      {items.map((it, idx) => {
        const key = isIconKey(it.icon) ? (it.icon as keyof typeof IconMap) : undefined;

        const row = (
          <>
            {key ? (
              <span className={iconBox} aria-hidden>
                <Icon name={key} className="h-6 w-6 text-primary" />
              </span>
            ) : it.iconImageUrl ? (
              <span className={iconBox} aria-hidden>
                <AppImage src={it.iconImageUrl} alt="" className="h-6 w-6 !object-contain" />
              </span>
            ) : null}

            <Typography
              variant="bodySm"
              className={cn(
                it.isBold ? '!font-bold' : 'font-normal',
                'group-hover:text-primary-500 transition-colors',
                'font-openSans',
              )}
            >
              {it.text}
            </Typography>
          </>
        );
        return (
          <SmartLink
            key={idx}
            href={it.href}
            target={it.target}
            className="group inline-flex items-center gap-sm w-fit"
          >
            {row}
          </SmartLink>
        );
      })}
    </div>
  );
}
